import { render, staticRenderFns } from "./DialogProfileComponent.vue?vue&type=template&id=05e74860&"
import script from "./DialogProfileComponent.vue?vue&type=script&lang=js&"
export * from "./DialogProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./DialogProfileComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports